// src/services/index.js
// Entry point for all services

import apiEndpoints from './api/endpoints';
import websocketService from './websocketService';
import AudioService from './AudioService';
import { authState } from './authState';
import { communicationService } from './communicationService';
import { storyService } from './storyService';
import { characterService } from './characterService';

// Export all services
export const services = {
  api: apiEndpoints,
  websocket: websocketService,
  audio: {
    createAudioService: () => new AudioService(),
    isSupported: AudioService.isSupported
  },
  // New centralized services
  authState,
  communication: communicationService,
  story: storyService,
  character: characterService
};

// Make available on window for debugging and direct access from WebSocket service
if (process.env.NODE_ENV === 'development') {
  window.services = services;
}

export default services;